// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { useEffect, useState } from "react";
import { CandidateContact, VerificationState } from "./types";

export const useCandidateContact = (appState: VerificationState | null): [CandidateContact | null, (contact: CandidateContact) => void] => {
  const [candidate, setCandidate] = useState<CandidateContact | null>(null);
  
  useEffect(() => {
    const firstContact = appState?.certifications?.[0]?.contact || appState?.awards?.[0]?.contact || null;
    if (firstContact) {
      setCandidate(firstContact);
    }
  }, [appState?.certifications, appState?.awards]);
  
  return [candidate, setCandidate];
};
